/**
 * Comandero's visual identity for the auth screens (kit #13 — de-clone).
 *
 * After de-cloning, the screens stop using the shared kit's 3-density brand
 * panel (`split`/`hero`/`aside`); the custom shell (`auth-kiosk.tsx`) only needs
 * the **brand glyph** and the **ambient illustration**. Distinctive motif: a
 * **comanda / service ticket** (not the logo's cloche),
 * `currentColor`/tokens → theme-safe.
 */

/**
 * Brand glyph for the chip: a **comanda ticket** with order lines and a
 * serrated bottom edge. Deliberately distinct from the logo (cloche) to give
 * the auth screens their own identity. `currentColor` = theme-safe.
 */
export function ComanderoMark(props: { class?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
      aria-hidden="true"
    >
      {/* Cuerpo del ticket */}
      <path
        d="M8 4h16v20l-2.5-1.7L19 24l-3-1.7L13 24l-2.5-1.7L8 24z"
        fill="currentColor"
        fill-opacity="0.18"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linejoin="round"
      />
      {/* Líneas de pedido */}
      <path
        d="M12 9.5h8M12 13h8M12 16.5h5"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  );
}

/**
 * Decorative illustration: a large comanda with order lines and a "served"
 * check. `aria-hidden`, `currentColor` so it looks good in any theme.
 */
export function TicketIllustration(props: { class?: string }) {
  return (
    <div class={`pointer-events-none ${props.class ?? ""}`} aria-hidden="true">
      <svg
        viewBox="0 0 320 320"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h-full w-auto max-w-none"
      >
        <circle cx="160" cy="160" r="150" stroke="currentColor" stroke-width="2" />
        <circle cx="160" cy="160" r="112" stroke="currentColor" stroke-width="2" />
        {/* Ticket de comanda */}
        <path
          d="M104 70h112v150l-14-10-14 10-14-10-14 10-14-10-14 10-14-10-14 10z"
          fill="currentColor"
          fill-opacity="0.5"
          stroke="currentColor"
          stroke-width="6"
          stroke-linejoin="round"
        />
        {/* Líneas de pedido */}
        <path
          d="M128 104h64M128 130h64M128 156h40"
          stroke="currentColor"
          stroke-width="7"
          stroke-linecap="round"
          stroke-opacity="0.85"
        />
        {/* Check de servido */}
        <path
          d="M132 186l12 12 24-26"
          stroke="currentColor"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
